<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<b-button
					v-if="$hasPermission('rates.add')"
					class="float-right"
					@click="newModel"
					>Nuevo plan</b-button
				>
				<h2>Planes tarifarios</h2>
				<hr />
				<b-form
					@submit="
						evt => {
							evt.preventDefault();
							this.$root.$emit(
								'bv::refresh::table',
								'rate-plans-index-list'
							);
						}
					"
				>
					<div class="row">
						<b-form-group class="col-2" label="Buscar">
							<b-form-input
								v-model="filters.search"
								type="text"
							/>
						</b-form-group>
						<b-form-group class="col-2" label="Moneda">
							<b-form-select
								v-model="filters.currency"
								:options="optCurrencies"
							></b-form-select>
						</b-form-group>
						<b-form-group class="col-3" label="Area">
							<multiselect
								:options="zoneAreasOpts"
								v-model="filters.zoneArea"
								:multiple="false"
								:show-labels="false"
								label="text"
								track-by="value"
							/>
						</b-form-group>
						<b-form-group class="col-2" label=".">
							<b-button type="submit" variant="primary"
								>Buscar</b-button
							>
						</b-form-group>
					</div>
				</b-form>
				<AjaxTable
					id="rate-plans-index-list"
					:filters="filters"
					:columns="modelColumns"
					resource="rate-plans"
					permission-show="rates.show"
				>
					<template v-slot:cell(actions)="row">
						<div class="text-center">
							<a
								:href="`/rate-plans-edit?id=${row.item.id}`"
								class="btn btn-sm mr-1 btn-warning"
								target="_blank"
								v-if="$hasPermission('prices.show')"
								content="Cotizar tarifa"
								v-tippy="{ arrow: true, arrowType: 'round' }"
							>
								<md-icon icon="attach_money" />
							</a>
							<b-button
								@click="
									event =>
										modelView(row.item, row.index, event)
								"
								type="button"
								size="sm"
								class="mr-1"
								variant="primary"
								content="Editar tarifa"
								v-tippy="{ arrow: true, arrowType: 'round' }"
							>
								<md-icon icon="edit" />
							</b-button>
							<b-button
								@click="inheritedRates(row.item)"
								type="button"
								size="sm"
								v-if="$hasPermission('rates.serviceType.show')"
								class="mr-1"
								variant="info"
								content="Asignar tipos de servicios"
								v-tippy="{ arrow: true, arrowType: 'round' }"
							>
								<md-icon icon="car_crash" />
							</b-button>
							<b-button
								@click="getSingleInheritedRates(row.item)"
								type="button"
								size="sm"
								v-if="$hasPermission('rates.serviceType.show')"
								class="mr-1"
								variant="success"
								content="Tarifas heredadas"
								v-tippy="{ arrow: true, arrowType: 'round' }"
							>
								<md-icon icon="manage_search" />
							</b-button>
							<b-button
								@click="
									event =>
										modelDelete(row.item, row.index, event)
								"
								type="button"
								v-if="$hasPermission('rates.delete')"
								size="sm"
								class="mr-1"
								variant="danger"
								content="Eliminar tarifa"
								v-tippy="{ arrow: true, arrowType: 'round' }"
							>
								<md-icon icon="delete" />
							</b-button>
						</div>
					</template>
				</AjaxTable>
			</div>
			<hr />
		</div>
		<Single
			:unableEdit.sync="unableEdit"
			:embbebedOnSupplier="embbebedOnSupplier"
			:supplierId="supplierId"
			ref="single"
			:success-callback="successCallback"
		/>
		<SingleInherited ref="singleInherited" />
		<SingleGetInheritedRates ref="singleGetInheritedRates" />
	</MainLayout>
</template>

<script>
import Multiselect from "vue-multiselect";
import MainLayout from "../layout/MainLayout";
import AjaxTable from "../../helpers/AjaxTable";
import Single from "./Single";
import SingleInherited from "./SingleInherited";
import SingleGetInheritedRates from "./SingleGetInheritedRates";

export default {
	props: {
		embbebedOnSupplier: {
			type: Boolean,
			default: false
		},
		supplierId: Number
	},
	components: { MainLayout, AjaxTable, Single, SingleInherited, Multiselect, SingleGetInheritedRates },
	data() {
		return {
			modelId: -1,
			unableEdit: false,
			filters: {
				search: "",
				currency: "",
				zoneArea: { value: "", text: "Seleccione una opción" }
			},
			optCurrencies: [
				{ value: "", text: "Seleccione una opción" },
				{ value: "usd", text: "USD" },
				{ value: "mxn", text: "MXN" }
			],
			modelColumns: [
				{ key: "id", label: "ID" },
				{ key: "name", label: "Nombre" },
				{ key: "currency", label: "Moneda" },
				{ key: "description", label: "Descripcion" },
				{ key: "averageConfiguration", label: "Precios configurados" },
				{ key: "zonedArea", label: "Area" },
				{ key: "parentRate", label: "Tarifa padre" },
				{ key: "actions", label: "Acciones" }
			]
		};
	},
	computed: {
		zoneAreasOpts() {
			return [
				{ value: "", text: "Seleccione una opción" },
				...this.$root.auxVars.zonedAreasOpts
			];
		}
	},
	methods: {
		successCallback() {
			this.$root.$emit("bv::refresh::table", "rate-plans-index-list");
		},
		modelView(item) {
			this.unableEdit = !this.$hasPermission("rates.edit");
			this.$refs["single"].loadModel(item.id);
		},
		inheritedRates(item) {
			this.$refs["singleInherited"].loadModel(item.id);
		},
		getSingleInheritedRates(item) {
			this.$refs["singleGetInheritedRates"].loadModel(item.id);
		},
		newModel() {
			this.unableEdit = false;
			this.$refs["single"].loadModel(-1);
		},
		modelDelete(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					this.$root.api
						.delete(`/rate-plans/${item.id}`)
						.then(response => {
							if (response.data.error) {
								this.$root.showAlert(response.data.message, {
									variant: "warning"
								});
								close();
								return false;
							}

							this.$root.showAlert("Registro Eliminado!", {
								variant: "warning"
							});
							this.$root.$emit(
								"bv::refresh::table",
								"rate-plans-index-list"
							);
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		}
	},
	mounted() {}
};
</script>

<style></style>
